import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { AccessTime, CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { formatVendorCaricamentoDate } from "../../../../utils/vendorDateTime";

const CardCaricamento = ({ job, previousJob = null, onOpenDetails }) => {
  const currentTotaleRecord = job.totaleRecord ?? 0;
  const currentTotaleErrori = job.totaleErrori ?? 0;

  const hasPreviousFromList = previousJob != null;
  const statoPrecedenteRecord = hasPreviousFromList
    ? (previousJob.totaleRecord ?? 0)
    : currentTotaleRecord;
  const statoPrecedenteErrori = hasPreviousFromList
    ? (previousJob.totaleErrori ?? 0)
    : currentTotaleErrori;

  const hasErrors = currentTotaleErrori > 0;

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2.5,
        borderRadius: "14px",
        mb: 2,
        backgroundColor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(4, minmax(0, 1fr))",
          },
          gap: 2,
          alignItems: "stretch",
        }}
      >
        {/* 1. Data e ora import */}
        <Box sx={{ textAlign: "center", minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 0.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Rubik",
                color: "primary.main",
                fontSize: 16,
              }}
            >
              Data e ora del caricamento
            </Typography>
            <AccessTime sx={{ fontSize: 20, color: "primary.main" }} />
          </Box>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontWeight: "bold",
              color: "#0b3d87",
              fontSize: 16,
            }}
          >
            {formatVendorCaricamentoDate(job.startTime)}
          </Typography>
        </Box>

        {/* 2. Stato prima dell'esecuzione attuale */}
        <Box sx={{ textAlign: "center", minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 0.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Rubik",
                color: "primary.main",
                fontSize: 16,
              }}
            >
              Stato precedente
            </Typography>
            {statoPrecedenteErrori > 0 ? (
              <ErrorOutline sx={{ fontSize: 20, color: "primary.main" }} />
            ) : (
              <CheckCircleOutline sx={{ fontSize: 20, color: "primary.main" }} />
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Rubik",
                fontSize: 16,
                color: "#0b3d87",
                fontWeight: "bold",
              }}
            >
              {statoPrecedenteRecord} prodotti -
            </Typography>
            <Typography
              sx={{
                fontFamily: "Rubik",
                fontSize: 16,
                color: statoPrecedenteErrori > 0 ? "error.main" : "#0b3d87",
                fontWeight: "bold",
              }}
            >
              {statoPrecedenteErrori} errori
            </Typography>
          </Box>
        </Box>

        {/* 3. Risultato esecuzione attuale */}
        <Box sx={{ textAlign: "center", minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 0.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Rubik",
                color: "primary.main",
                fontSize: 16,
              }}
            >
              Risultato importazione
            </Typography>
            {
              currentTotaleErrori > 0 ? <ErrorOutline sx={{ fontSize: 20, color: "primary.main" }} /> : <CheckCircleOutline sx={{ fontSize: 20, color: "primary.main" }} />
            }
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}
          >
          <Typography
            sx={{
              fontFamily: "Rubik",
              color: "#0b3d87",
              fontSize: 16,
              fontWeight: "bold",
            }}
          >
            {currentTotaleRecord} prodotti - 
          </Typography>
          <Typography
            sx={{
              fontFamily: "Rubik",
              fontSize: 16,
              fontWeight: "bold",
              color: currentTotaleErrori > 0 ? "error.main" : "#0b3d87",
            }}
          >
            {currentTotaleErrori} errori
          </Typography>
          </Box>
        </Box>

        {/* 4. Dettagli importazione */}
        <Box
          sx={{
            textAlign: "center",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="outlined"
            onClick={onOpenDetails}
            sx={{
              fontFamily: "Rubik",
              textTransform: "none",
              borderRadius: "24px",
              px: 2,
              fontWeight: "bold",
              borderColor: "#0b3d87",
              color: "#0b3d87",
              "&:hover": {
                borderColor: "#092b6a",
                backgroundColor: "rgba(11,61,135,0.06)",
              },
            }}
          >
            Dettagli importazione
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CardCaricamento;

